export default __webpack_public_path__ + "static/media/about1.2694c5b7.png";